import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from '@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal';
import { EmailMeModalProps } from './EmailMeModal.d';
import { Analytics, ACTION, LOCATION, DESCRIPTION } from '../../helpers/analytics/analytics';
import { EmailMeModalContent } from '../EmailMeModalContent/EmailMeModalContent';

export const EmailMeModal: React.FC<EmailMeModalProps> = observer((props: EmailMeModalProps) => {
    const { emailModalStore } = props;
    const { isEmailMeModalOpen } = emailModalStore;

    useEffect(() => {
        if (isEmailMeModalOpen) {
            Analytics.dispatchAdobeAnalytics(
                ACTION.EMWBIS_MODAL_OPEN,
                LOCATION.PDP_WISH_LIST_WIDGET,
                DESCRIPTION.EMWBIS,
            );
        }
    }, [isEmailMeModalOpen]);

    if (!isEmailMeModalOpen) return null;

    return (
        <Modal
            data-testid="emwbis-model"
            isOpen={true}
            title="Email when in stock"
            onClose={(): void => emailModalStore.closeEmailMeModal()}
            footer={false}
        >
            <EmailMeModalContent
                emailModalStore={emailModalStore}
                onCancel={(): void => emailModalStore.closeEmailMeModal()}
                onNotify={(): Promise<void> => emailModalStore.emailMe()}
            />
        </Modal>
    );
});
